import { IconMail } from "@tabler/icons-react";

type Config = {
	siteName: string;
	/** Icon component used when `siteLogoSrc` is unset. */
	siteLogo: React.ElementType;
	/** Optional image in `public/`; takes precedence over `siteLogo`. */
	siteLogoSrc?: string;
	siteUrl: string;
	supportEmail: string;
	siteDescription: string;
	changelog: {
		show_last_versions: number;
		show_updates_per_version: number;
	};
	marketingHeader: {
		showAuthLinks: boolean;
	};
	Socials: {
		Twitter?: string;
		Github?: string;
		Linkedin?: string;
		Instagram?: string;
	};
	/** Global footer “project by …” link */
	projectAttribution: {
		url: string;
		displayName: string;
	};
	/** Substituted into legal markdown via content-collections (`{{companyName}}`, etc.). */
	legal: {
		companyName: string;
		legalName: string;
		address: string;
		legalEmail: string;
		privacyEmail: string;
		/** Used in legal pages and `/.well-known/security.txt` (RFC 9116). */
		securityEmail: string;
		effectiveDate: string;
		governingLaw: string;
		governingLawVenue: string;
	};
	/** Native app store links when `mobile_app` module is on (see `src/lib/mobile-app.ts`). */
	mobileApp?: {
		iosAppStoreUrl?: string;
		googlePlayUrl?: string;
		deepLinkScheme?: string;
	};
};

export const config: Config = {
	siteName: "ineedatest.email",
	siteLogo: IconMail,
	siteLogoSrc: "/logo.png",
	siteUrl: "https://ineedatest.email",
	supportEmail: "support@ineedatest.email",
	siteDescription: "A disposable email service",
	changelog: {
		show_last_versions: 5,
		show_updates_per_version: 3,
	},

	marketingHeader: {
		showAuthLinks: false,
	},

	Socials: {
		Twitter: "https://twitter.com/frncis",
		Github: "https://github.com/baker",
		Linkedin: "https://linkedin.com/in/francisbaker",
	},

	projectAttribution: {
		url: "https://francispbaker.com",
		displayName: "FrancisPBaker.com",
	},

	legal: {
		companyName: "ineedatest.email",
		legalName: "Francis Baker",
		address: "United States",
		legalEmail: "legal@ineedatest.email",
		privacyEmail: "privacy@ineedatest.email",
		securityEmail: "security@ineedatest.email",
		effectiveDate: "May 23, 2026",
		governingLaw: "the laws of the State of Delaware",
		governingLawVenue: "Delaware",
	},
};
